import { render, staticRenderFns } from "./text-image-alt.vue?vue&type=template&id=0dc495a0&scoped=true"
import script from "./text-image-alt.vue?vue&type=script&lang=js"
export * from "./text-image-alt.vue?vue&type=script&lang=js"
import style0 from "./text-image-alt.vue?vue&type=style&index=0&id=0dc495a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dc495a0",
  null
  
)

export default component.exports